import React from 'react';
import classnames from 'classnames';
import { Price } from 'swag-client-common/utils/price';
import { SetupFeeTooltip } from 'swag-client-common/components/partials/setupfee-tooltip';
import classes from '../../instant-quote-popup.scss';
export const PriceSummary = ({
  totalPrice,
  shippingPrice,
  pricePerItem,
  taxesPrice,
  setupFee,
  isLimitedEdition,
  isCustomizedBlank,
  isFullDesignProduct
}) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
  className: classes.prices
}, /*#__PURE__*/React.createElement("div", {
  className: classes.priceFormation
}, /*#__PURE__*/React.createElement("div", {
  className: classes.priceRow
}, /*#__PURE__*/React.createElement("div", {
  className: classes.secondaryText
}, "Each item"), /*#__PURE__*/React.createElement("h5", {
  className: classes.pricePerItem,
  "data-text": "PricePerItem"
}, Price.formatPrice(pricePerItem))), !isCustomizedBlank && /*#__PURE__*/React.createElement("div", {
  className: classes.priceRow
}, /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.secondaryText, classes.mw60)
}, "Setup fee"), /*#__PURE__*/React.createElement("div", {
  className: classes.setupFeeTooltip
}, !isFullDesignProduct && /*#__PURE__*/React.createElement(SetupFeeTooltip, {
  infoWrapperClassName: classes.setupFeeInfoWrapper,
  isLimitedEdition: isLimitedEdition,
  totalSharedSetupFee: setupFee || null
})), /*#__PURE__*/React.createElement("h5", {
  className: classes.pricePerItem,
  "data-text": "SetupFee"
}, Price.formatPrice(setupFee))), /*#__PURE__*/React.createElement("div", {
  className: classes.priceRow
}, /*#__PURE__*/React.createElement("div", {
  className: classes.secondaryText
}, "Taxes"), /*#__PURE__*/React.createElement("h5", {
  className: classes.pricePerItem,
  "data-text": "TaxesPrice"
}, Price.formatPrice(taxesPrice))), /*#__PURE__*/React.createElement("div", {
  className: classes.priceRow
}, /*#__PURE__*/React.createElement("div", {
  className: classes.secondaryText
}, "Shipping"), /*#__PURE__*/React.createElement("h5", {
  className: classes.pricePerItem,
  "data-text": "Shipping"
}, Number.isFinite(Number(shippingPrice)) && Number(shippingPrice) > 0 ? Price.formatPrice(shippingPrice) : shippingPrice))), /*#__PURE__*/React.createElement("div", {
  className: classes.totalPrice
}, /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.secondaryText, classes.totalText)
}, "Total:"), /*#__PURE__*/React.createElement("h5", {
  className: classnames(classes.prodPrice, {
    [classes.orangeColor]: isLimitedEdition
  }),
  "data-text": "Total"
}, Price.formatPrice(totalPrice)))));